function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-profile{fill:none;}.cls-2-profile{fill:#48a9a0;opacity:0.2;}.cls-3-profile{fill:#47a9a0;}.cls-4-profile{fill:#5b5b5b;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Warstwa_2",
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Warstwa_1-2",
  "data-name": "Warstwa 1"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  className: "cls-1-profile",
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  className: "cls-2-profile",
  d: "M10.3,9.28A4.2,4.2,0,1,0,6.11,5.07,4.19,4.19,0,0,0,10.3,9.28Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  className: "cls-2-profile",
  d: "M12.47,10.57H8.14A5.83,5.83,0,0,0,2.3,16.41a.58.58,0,0,0,.58.59H17.77a.58.58,0,0,0,.59-.59,5.83,5.83,0,0,0-1.73-4.15A5.89,5.89,0,0,0,12.47,10.57Z"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  className: "cls-3-profile",
  cx: 9.31,
  cy: 6.84,
  r: 4.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "cls-4-profile",
  d: "M16.78,18.91h-15a.59.59,0,0,1-.59-.58,5.9,5.9,0,0,1,5.85-5.9H11.4a5.9,5.9,0,0,1,5.85,5.9A.58.58,0,0,1,16.78,18.91ZM2.46,17.74h13.7a4.67,4.67,0,0,0-4.68-4.14H7.15A4.73,4.73,0,0,0,2.46,17.74Z"
})));

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Profile.ed5ea2b6.svg";
export { ForwardRef as ReactComponent };